export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_DELETED_GUIDE': {
      return {
        ...state,
        deletedGuide: action.data,
      };
    }
    default: {
      return state;
    }
  }
};
